import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { APP_STORE_URL, PLAY_STORE_URL } from '../../lib/seo';
import { useLocalizedPath } from '../../hooks/useLocalizedContent';

function AppCta({ title, text }) {
  const { t } = useTranslation();
  const toPath = useLocalizedPath();
  return (
    <aside className="app-cta" id="download-app">
      <div className="app-cta-copy">
        <h2>{title || t('knowledge.cta.title')}</h2>
        <p>{text || t('knowledge.cta.text')}</p>
      </div>
      <div className="cta-buttons">
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="download-btn download-btn-apple"
        >
          <img src="/apple.svg" alt="Apple" className="download-btn-icon" />
          <div className="download-btn-text">
            <span className="download-btn-label">Download on the</span>
            <span className="download-btn-name">App Store</span>
          </div>
        </a>
        <a
          href={PLAY_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="download-btn download-btn-google"
        >
          <img src="/google.svg" alt="Google Play" className="download-btn-icon" />
          <div className="download-btn-text">
            <span className="download-btn-label">GET IT ON</span>
            <span className="download-btn-name">Google Play</span>
          </div>
        </a>
      </div>
      <p className="app-cta-more">
        <Link to={toPath('/foods')}>{t('knowledge.cta.browseFoods')}</Link>
        {' · '}
        <Link to={toPath('/guides')}>{t('knowledge.cta.browseGuides')}</Link>
      </p>
    </aside>
  );
}

export default AppCta;
